<template>
        <button
          class="theme-switch"
          :class="{ active: isDark }"
          type="button"
          role="switch"
          :aria-checked="isDark"
          :aria-label="isDark ? 'Switch to light theme' : 'Switch to dark theme'"
          @click="toggleTheme"
        >
          <span class="theme-switch-thumb">
            <svg v-if="isDark" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20.5 15.7A8.8 8.8 0 0 1 8.3 3.5 8.8 8.8 0 1 0 20.5 15.7Z"></path>
            </svg>
            <svg v-else viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="4"></circle>
              <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1"></path>
            </svg>
          </span>
        </button>
</template>
<script>
import useTheme from '../composables/useTheme';
export default { setup: useTheme };
</script>
